import { render, staticRenderFns } from "./technical-support.vue?vue&type=template&id=39c4f188&"
import script from "./technical-support.vue?vue&type=script&lang=js&"
export * from "./technical-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports